/*
 ** Genesys Client API for Frontend site
 */

import Logger from '../../common/logger';
import IPC from '../helpers/ipc';
import GenesysTools from '../../common/GenesysTools';
import { pushGTMEvent } from '../helpers/googleAnalytics';

const TRACKER_TIMEOUT = 30;

const COMMAND = {
    SENDINVITERESULT: 'TRACKER_INVITERESULT',
    SENDVIEWRESULT: 'TRACKER_VIEW_RESULT',
    SENDEVENT: 'TRACKER_EVENT',
    // request config
    GETCONFIG: 'TRACKER_GETCONFIG',
    // send config to child
    CONFIG: 'TRACKER_CONFIG'
};

class TrackerApi {
    constructor() {
        this.trackerConfig = null;
        this.onReadyCallbacks = [];

        this.messageHandler = this.messageHandler.bind(this);
        IPC.onEvent(this.messageHandler);

        this.scriptReadyHandler = this.scriptReadyHandler.bind(this);
        this.waitForCookie(
            'genesys.tracker.visitID',
            this.scriptReadyHandler,
            TRACKER_TIMEOUT,
            () => {
                Logger.warn('[TRACKER] Missed cookie');
            }
        );
        // wait for cookie created by _gt tracker
    }

    waitForCookie(name, callback, timeout, timeoutCallback = null) {
        const interval = 500;
        let total = 0;
        const hasItem = (sKey) => {
            if (!sKey) {
                return false;
            }
            return new RegExp(
                '(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\='
            ).test(document.cookie);
        };
        const retryCallback = function () {
            if (hasItem(name)) {
                callback();
            } else {
                if (total >= timeout * 1000) {
                    if (timeoutCallback) {
                        timeoutCallback();
                    }
                    return;
                }
                total += interval;
                setTimeout(retryCallback, interval);
            }
        };

        setTimeout(retryCallback, interval);
    }

    onReady(callback) {
        if (callback) {
            this.onReadyCallbacks.push(callback);
        }
    }

    scriptReadyHandler() {
        Logger.log('[TRACKER] Genesys tracker loaded and started');

        // get tracker config
        window._gt.push([
            'getConfig',
            (config) => {
                this.trackerConfig = config;
            }
        ]);

        this.onReadyCallbacks.forEach((callback) => callback(), this);
    }

    messageHandler(message) {
        switch (message.command) {
            case COMMAND.SENDINVITERESULT:
                this.sendInviteResult(message.data);
                break;
            case COMMAND.SENDEVENT:
                this.sendEvent(message.data);
                break;
            case COMMAND.GETCONFIG:
                IPC.sendEvent(COMMAND.CONFIG, this.getConfig());
                break;
            case COMMAND.SENDVIEWRESULT:
                pushGTMEvent(message.data, Logger);
                break;
            default:
                break;
        }
    }

    getConfig() {
        return GenesysTools.getInvite();
    }

    sendInviteResult({ code, media, engagementID }) {
        if (this.trackerConfig) {
            Logger.log('[TRACKER] sendInviteResult: ' + code);
            var url =
                this.trackerConfig.internal.currentEndpoint +
                '/server/data/invites' +
                '?result=' +
                code +
                '&pageID=' +
                this.trackerConfig.internal.pageID +
                '&visitID=' +
                this.trackerConfig.internal.visitID +
                '&alias=' +
                this.trackerConfig.internal.alias;

            if (media) {
                url = url + '&media=' + media;
            }

            if (engagementID) {
                url = url + '&engagementID=' + engagementID;
            }

            /* Sending using img tag for speed(could be on unload event) and browser compatibility */
            this.sendUsingIMG(url);
        }
    }

    sendUsingIMG(url) {
        const h = new window.Image();
        const heads = window.document.getElementsByTagName('head');

        h.src = url;
        h.style.display = 'none';
        h.onload = () => {
            h.onload = null;
        };

        if (heads.length > 0) {
            heads[0].appendChild(h);
        } else {
            window.document.body.appendChild(h);
        }
    }

    sendEvent({ event, data }) {
        Logger.log('[TRACKER] SendEvent: ' + event);
        const payload = ['event', event];
        if (data) {
            payload.push({ data });
        }
        window._gt.push(payload);
    }
}

export default TrackerApi;
